export default __webpack_public_path__ + "static/media/maitreDupont.1a90e6ba.png";